import React from "react";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import { Link } from "react-router-dom";

import { Menu, MenuItem, Popover } from "@blueprintjs/core";

const UserActions = (props) => {
  let detailsUrl = `/users/details/${props.user.customerId}`;

  const optionsMenu = (
    <Menu>
      <Link to={detailsUrl}>View Details</Link>
      {/* <MenuItem
        onClick={() =>
          props.onEditClicked ? props.onEditClicked() : undefined
        }
        text="Edit"
      /> */}
      {props.user.status !== "suspended" ? (
        <MenuItem
          text="Suspend"
          onClick={() =>
            props.suspend ? props.suspend(props.user) : undefined
          }
        />
      ) : (
        <MenuItem
          text="Unsuspend"
          onClick={() =>
            props.unsuspend ? props.unsuspend(props.user) : undefined
          }
        />
      )}

      <MenuItem
        text="Send Email"
        onClick={() =>
          props.sendEmail ? props.sendEmail(props.user) : undefined
        }
      />
      <MenuItem
        text="Send SMS"
        onClick={() => (props.sendSMS ? props.sendSMS(props.user) : undefined)}
      />
      {props.user.email_verified === false ? (
        <MenuItem
          text="Verify Account"
          onClick={() => (props.verify ? props.verify(props.user) : undefined)}
        />
      ) : (
        ""
      )}
      <MenuItem
        text="Delete"
        onClick={() => (props.remove ? props.remove(props.user) : undefined)}
      />
    </Menu>
  );
  return (
    <div>
      <div className="more-details-ellipsis-container">
        <Popover content={optionsMenu} position="bottom">
          <DotsHorizontalIcon />
        </Popover>
      </div>
    </div>
  );
};

export default UserActions;
